import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyFcfa'
})
export class CurrencyFcfaPipe implements PipeTransform {

  transform(value: number, fractionDigits: string = '1.0-0'): string {
    const formattedValue = new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
    return `${formattedValue} FCFA`;
  }

}
